import { capaActiva, removeLegend } from "../capaActiva";
import { getUid } from "ol";
import ImageLayer from "ol/layer/Image";
import VectorLayer from "ol/layer/Vector";
import { V } from "ol/renderer/webgl/FlowLayer";

//Evento de cambio de capa
export function onLayerVisibilityChange(event, view) {
  console.log(event);
  const layer = event.target;

  //console.log('-- on Layer --',layer)
  //verificar si es base
  const type = layer.get("type");

  if ((type != "base") & (layer instanceof ImageLayer)) {
    if (layer.getVisible()) {
      //console.log('La capa "' + layerName + '" está ahora visible.');

      //vector layers intento de trabajar con vectores en vez de imgages
      capaActiva(layer, view, getUid(layer));
    } else {
      //console.log('La capa "' + layerName + '" está ahora oculta.');
      //console.log('capa no visible')
      removeLegend(layer.getSource().getParams().LAYERS);
    }
  }
}
